import { createFileRoute } from '@tanstack/react-router';
import CollectionsIndexPage from '@/pages/workspaces/journeys/collections/index.page';
import { LazyPage } from './-route-layouts';

export function CollectionsIndexRoute() {
  return (
    <LazyPage>
      <CollectionsIndexPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/')({
  component: CollectionsIndexRoute,
});
